/* Theme-only review presentation safeguards. No review data is changed. */
(() => {
  'use strict';

  const entityPattern = /(?:&amp;)?(?:#(?:x27|39)|apos|quot);/i;

  const decodeEntities = (value) => {
    let decoded = value;
    for (let index = 0; index < 2 && entityPattern.test(decoded); index += 1) {
      const decoder = document.createElement('textarea');
      decoder.innerHTML = decoded;
      decoded = decoder.value;
    }
    return decoded;
  };

  const normaliseVisibleText = (widget) => {
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (entityPattern.test(node.nodeValue)) node.nodeValue = decodeEntities(node.nodeValue);
    });
  };

  // The widget exposes its real state through the hidden attribute: one of
  // loading, error, empty and list is visible at a time. The whole widget text
  // is not a source: it also carries the JSON translation strings. The ="" form
  // skips the form field errors, which reuse data-imr-error with a value.
  const isShown = (widget, selector) => {
    const node = widget.querySelector(selector);
    return Boolean(node) && !node.hidden;
  };

  // null means "not known yet": still loading, failed, or no count rendered.
  const getReviewCount = (widget) => {
    if (isShown(widget, '[data-imr-loading=""]') || isShown(widget, '[data-imr-error=""]')) return null;
    const source = widget.querySelector('[data-imr-count]')?.textContent || '';
    const match = source.match(/(?:^|\D)(\d+)\s+recension(?:e|i)\b/i);
    const count = match ? Number(match[1]) : null;
    // Empty with a positive total is only a filter without results.
    if (isShown(widget, '[data-imr-empty=""]')) return count || 0;
    return count || null;
  };

  const matchingCarousel = (widget) => {
    const productId = widget.dataset.productId;
    if (!productId) return null;
    return [...document.querySelectorAll('.immershop-review-carousel immershop-review-carousel')]
      .find((carousel) => carousel.dataset.productId === productId)
      ?.closest('.immershop-review-carousel');
  };

  const renderEmptyState = (widget, count) => {
    const isEmpty = count === 0;
    widget.classList.toggle('imr-theme-empty', isEmpty);
    matchingCarousel(widget)?.classList.toggle('imr-theme-empty-carousel', isEmpty);

    const existing = widget.querySelector('[data-imr-theme-empty-state]');
    if (!isEmpty) {
      existing?.remove();
      return;
    }
    if (existing) return;

    const state = document.createElement('div');
    state.className = 'imr-theme-empty-state';
    state.dataset.imrThemeEmptyState = '';

    const invitation = document.createElement('p');
    invitation.textContent = "Sii il primo a raccontare com'è andata.";
    state.append(invitation);

    const writeReview = widget.querySelector('[data-imr-open-form]');
    if (writeReview) state.append(writeReview);
    widget.append(state);
  };

  const sync = (widget) => {
    normaliseVisibleText(widget);
    const count = getReviewCount(widget);
    if (count !== null) renderEmptyState(widget, count);
  };

  const bindFormTriggerFallback = (widget) => {
    if (widget.dataset.imrThemeFormFallback === 'true') return;
    widget.dataset.imrThemeFormFallback = 'true';
    widget.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-imr-open-form]');
      if (!trigger) return;
      const form = widget.querySelector('[data-imr-form]');
      if (!form) return;
      form.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => form.querySelector('input, textarea, button')?.focus());
    });
  };

  const observe = (widget) => {
    bindFormTriggerFallback(widget);
    let scheduled = false;
    const queueSync = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        sync(widget);
      });
    };
    new MutationObserver(queueSync).observe(widget, { childList: true, subtree: true, characterData: true });
    queueSync();
  };

  const start = () => document.querySelectorAll('immershop-reviews').forEach(observe);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
